// extracted by mini-css-extract-plugin
module.exports = {"AdditionalHighlights":"styles_AdditionalHighlights__FzaGq","bg_1":"styles_bg_1__ZvcsE","card":"styles_card__lXbJl","height":"styles_height__HJHHE"};